import { render, staticRenderFns } from "./ContratosRenovar.vue?vue&type=template&id=0de2d797&"
import script from "./contratosRenovar.js?vue&type=script&lang=js&"
export * from "./contratosRenovar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports